import TVdxbApplicationInviteUser from './index.vue';

TVdxbApplicationInviteUser.install = app => {
  app.component(TVdxbApplicationInviteUser.name, TVdxbApplicationInviteUser);
};

export default TVdxbApplicationInviteUser;
